<div class="stepper-body">
    <div class="body-title">
        <span>What source of income are you using to qualify for this loan?</span>
    </div>
    <div class="body-description">
        <span>Select all that apply.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(IncomeSourceOptions.W2)
                        }" (click)="onAnswerSelected(IncomeSourceOptions.W2)">
                {{IncomeSourceOptions.W2}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(IncomeSourceOptions.SelfEmployment)
                        }" (click)="onAnswerSelected(IncomeSourceOptions.SelfEmployment)">
                {{IncomeSourceOptions.SelfEmployment}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(IncomeSourceOptions.OtherIncome)
                        }" (click)="onAnswerSelected(IncomeSourceOptions.OtherIncome)">
                {{IncomeSourceOptions.OtherIncome}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>